import React from 'react'
import { useFirebaseApp } from 'reactfire'
import 'firebase/performance'
import 'firebase/firestore'

import { Box, Button, Header, Heading, Main, Paragraph } from 'grommet'

import { emptyProperty } from '../../utils/emptyProperty'
import ScraperForm from '../ScraperForm/ScraperForm'

const AddProperty = (props) => {
  const firebaseApp = useFirebaseApp()
  const randomID =
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)

  const handleCreate = () => {
    firebaseApp
      .firestore()
      .collection(props.userID)
      .doc(randomID)
      .set(emptyProperty)
      .then(function() {
        // eslint-disable-next-line no-console
        console.info('Document successfully Created!')
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.error('Error creating document: ', error)
      })
  }

  return (
    <Main>
      <Header background="brand" pad="medium">
        <Heading
          level={1}
          style={{ fontSize: '3rem', textAlign: 'center', width: '100%' }}
        >
          Add a new Property
        </Heading>
      </Header>
      <Box pad="medium">
        <Heading level={2} style={{ fontSize: '2.5rem' }}>
          Import from Hemnet
        </Heading>

        <Paragraph style={{ padding: '8px 0' }}>
          Copy the link from the hemnet property you want to add and click import.
        </Paragraph>
        <ScraperForm />
      </Box>

      <Box pad="medium" style={{ opacity: '.5', pointerEvents: 'none' }}>
        <Heading level={2} style={{ fontSize: '2.5rem' }}>
          Import from Booli
        </Heading>
        <Paragraph style={{ padding: '8px 0' }}>Coming soon</Paragraph>
        <ScraperForm />
      </Box>

      <Box pad="medium">
        <Heading level={2}>Create a new Property</Heading>
        <Paragraph style={{ padding: '16px 0' }}>
          Create a new property without any information. Use this if your property is not
          available at Hemnet or Booli
        </Paragraph>
        <Button
          label="Create Property"
          onClick={handleCreate}
          style={{ maxWidth: 'max-content' }}
        />
      </Box>
    </Main>
  )
}

export default AddProperty
